import { render, staticRenderFns } from "./BusinessTvService.vue?vue&type=template&id=99dffc58&scoped=true&"
import script from "./BusinessTvService.ts?vue&type=script&lang=ts&"
export * from "./BusinessTvService.ts?vue&type=script&lang=ts&"
import style0 from "../shared/ServicesView.less?vue&type=style&index=0&id=99dffc58&prod&lang=less&scoped=true&"
import style1 from "./BusinessTvService.vue?vue&type=style&index=1&id=99dffc58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dffc58",
  null
  
)

export default component.exports